import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { DuctProperties } from '../../../../span-progress-entities';

@Component({
  selector: 'app-reportable-popup-shell',
  templateUrl: './reportable-popup-shell.component.html',
  styleUrl: './reportable-popup-shell.component.scss',
  standalone: false,
})
export class ReportablePopupShellComponent {
  @Input() paragraphHeadingText: string;
  @Input() status: string;
  @Input() isLoading = false;
  @Input() downloadTooltipLabel: string;
  @Input() primaryButtonText: string;
  @Input() secondaryButtonText: string;

  incomingDucts = input<DuctProperties[] | undefined>();
  outgoingDucts = input<DuctProperties[] | undefined>();

  @Output() trigger = new EventEmitter<MouseEvent>();
  @Output() triggerKeydown = new EventEmitter<KeyboardEvent>();
  @Output() primaryButtonClick = new EventEmitter<void>();
  @Output() secondaryButtonClick = new EventEmitter<void>();
}
